
export interface ClientLogo {
  id: number;
  name: string;
  logo: string;
}

export const clientLogos: ClientLogo[] = [
  { id: 1, name: 'Client Partner 1', logo: '/saroop/happy-customer-logo/1.png' },
  { id: 2, name: 'Client Partner 2', logo: '/saroop/happy-customer-logo/2.jpg' },
  { id: 3, name: 'Client Partner 3', logo: '/saroop/happy-customer-logo/3.png' },
  { id: 4, name: 'Client Partner 4', logo: '/saroop/happy-customer-logo/4.jpeg' },
  { id: 5, name: 'Client Partner 5', logo: '/saroop/happy-customer-logo/5.png' },
  { id: 6, name: 'Client Partner 6', logo: '/saroop/happy-customer-logo/6.png' },
  { id: 7, name: 'Client Partner 7', logo: '/saroop/happy-customer-logo/7.png' },
  { id: 8, name: 'Client Partner 8', logo: '/saroop/happy-customer-logo/8.jpg' },
  { id: 9, name: 'Client Partner 9', logo: '/saroop/happy-customer-logo/9.PNG' },
  { id: 10, name: 'Client Partner 10', logo: '/saroop/happy-customer-logo/10.png' },
  { id: 11, name: 'Client Partner 11', logo: '/saroop/happy-customer-logo/11.png' },
  { id: 12, name: 'Client Partner 12', logo: '/saroop/happy-customer-logo/12.jpg' },
  { id: 13, name: 'Client Partner 13', logo: '/saroop/happy-customer-logo/13.jpg' },
  { id: 14, name: 'Client Partner 14', logo: '/saroop/happy-customer-logo/14.jpeg' },
  { id: 15, name: 'Client Partner 15', logo: '/saroop/happy-customer-logo/15.png' },
  { id: 16, name: 'Client Partner 16', logo: '/saroop/happy-customer-logo/16.png' },
  { id: 17, name: 'Client Partner 17', logo: '/saroop/happy-customer-logo/PMI.webp' },
  { id: 18, name: 'Client Partner 18', logo: '/saroop/happy-customer-logo/motherson.png'},
];
